import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const SifaEnerjiPage = () => {
  const services = [
    {
      id: 1,
      title: 'Enerji Şifa Seansı',
      description: 'Bedeninizin ve ruhunuzun enerji alanını temizleyen, dengeleyen ve yenileyen şifa seansları ile kendinizi yenileyin.',
      duration: '60 dakika',
      price: 'Fiyat için iletişime geçin',
      includes: [
        'Enerji alanı taraması',
        'Çakra dengeleme',
        'Aura temizliği',
        'Enerji blokajlarının açılması',
        'Şifa enerjisi aktarımı',
        'Koruma ve güçlendirme',
        'Seans kaydı (isteğe bağlı)'
      ]
    },
    {
      id: 2,
      title: 'Çakra Dengeleme',
      description: 'Yedi ana çakranızın dengelenmesi ve uyumlu hale getirilmesi ile fiziksel, duygusal ve ruhsal sağlığınızı destekleyin.',
      duration: '75 dakika',
      price: 'Fiyat için iletişime geçin',
      includes: [
        'Çakra analizi ve tarama',
        'Her çakra için özel çalışma',
        'Enerji akışının düzenlenmesi',
        'Kristal ve frekans desteği',
        'Meditasyon teknikleri',
        'Günlük uygulama önerileri',
        'Seans kaydı (isteğe bağlı)'
      ]
    },
    {
      id: 3,
      title: 'Frekans & Titreşim Çalışması',
      description: 'Yüksek frekanslı enerji çalışmaları ile titreşiminizi yükseltin ve yaşam kalitenizi artırın.',
      duration: '60 dakika',
      price: 'Fiyat için iletişime geçin',
      includes: [
        'Frekans ölçümü ve analizi',
        'Titreşim yükseltme teknikleri',
        'Ses ve müzik terapisi',
        'Kristal frekans çalışması',
        'Enerji kodlaması',
        'Kişisel frekans ayarı',
        'Seans kaydı (isteğe bağlı)'
      ]
    },
    {
      id: 4,
      title: 'Uzaktan Enerji Şifası',
      description: 'Mesafe tanımayan enerji şifa seansları ile dünyanın her yerinden şifa enerjisi alın.',
      duration: '45 dakika',
      price: 'Fiyat için iletişime geçin',
      includes: [
        'Uzaktan enerji bağlantısı',
        'Şifa enerjisi gönderimi',
        'Enerji temizliği',
        'Koruma kalkanı oluşturma',
        'Seans raporu',
        'Takip desteği',
        'Seans kaydı (isteğe bağlı)'
      ]
    }
  ];

  const benefits = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Fiziksel Sağlık',
      desc: 'Bedeninizin doğal şifa süreçlerini destekleyin'
    },
    {
      icon: 'ri-emotion-line',
      title: 'Duygusal Denge',
      desc: 'Duygusal blokajları çözün ve dengeyi bulun'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Enerji Artışı',
      desc: 'Yaşam enerjinizi yükseltin ve canlılık kazanın'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Koruma',
      desc: 'Negatif enerjilerden korunun ve güçlenin'
    }
  ];

  const suitableFor = [
    'Enerji dengesizliği yaşayanlar',
    'Kronik yorgunluk hissedenler',
    'Stres ve gerginlik yaşayanlar',
    'Fiziksel rahatsızlıkları olanlar',
    'Duygusal blokajları olanlar',
    'Ruhsal gelişim isteyenler'
  ];

  const energyTypes = [
    {
      title: 'Reiki',
      desc: 'Japon kökenli evrensel yaşam enerjisi şifası'
    },
    {
      title: 'Pranic Healing',
      desc: 'Prana enerjisi ile şifa ve temizlik'
    },
    {
      title: 'Kristal Şifa',
      desc: 'Kristallerin şifa frekansları ile çalışma'
    },
    {
      title: 'Ses Şifası',
      desc: 'Ses dalgaları ve frekanslarla iyileşme'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-b from-primary-dark to-primary-navy overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle, #D4AF37 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <div className="inline-block px-6 py-2 bg-gold/20 rounded-full mb-6">
              <span className="text-gold text-sm font-medium uppercase tracking-wider">Enerji & Şifa</span>
            </div>
            <h1 className="font-serif text-5xl lg:text-7xl font-bold text-white mb-6">
              Şifa & Enerji Çalışmaları
            </h1>
            <p className="text-xl text-text-light max-w-3xl mx-auto leading-relaxed">
              Bedeninizi ve ruhunuzu uyumlu hale getirin, enerji dengenizi sağlayın ve 
              doğal şifa süreçlerinizi aktive edin
            </p>
          </motion.div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h2 className="font-serif text-4xl font-bold text-primary-dark mb-6">
              Enerji Şifası Nedir?
            </h2>
            <p className="text-text-medium text-lg leading-relaxed mb-6">
              Enerji şifası, bedenin ve ruhun doğal enerji alanı üzerinde çalışarak, 
              blokajları açan, dengeyi sağlayan ve şifa süreçlerini destekleyen 
              kadim bir iyileşme yöntemidir.
            </p>
            <p className="text-text-medium text-lg leading-relaxed">
              15+ yıllık deneyimimle, çeşitli enerji şifa modalitelerini kullanarak 
              size özel şifa seansları sunuyor ve enerji dengenizi sağlamanıza yardımcı oluyorum.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
              Enerji Şifasının Faydaları
            </h2>
            <p className="text-text-medium text-lg">
              Enerji çalışmaları ile neler kazanırsınız?
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-3xl p-8 text-center hover:shadow-2xl transition-all duration-500"
              >
                <div className="w-16 h-16 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${benefit.icon} text-gold text-3xl`}></i>
                </div>
                <h3 className="font-serif text-xl font-bold text-primary-dark mb-3">
                  {benefit.title}
                </h3>
                <p className="text-text-medium text-sm leading-relaxed">
                  {benefit.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Energy Types */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
              Kullandığım Enerji Modaliteleri
            </h2>
            <p className="text-text-medium text-lg">
              Farklı şifa yöntemleri ile size özel yaklaşım
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {energyTypes.map((type, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-cream rounded-2xl p-6 text-center"
              >
                <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-sparkling-2-line text-gold text-xl"></i>
                </div>
                <h3 className="font-serif text-lg font-bold text-primary-dark mb-2">
                  {type.title}
                </h3>
                <p className="text-sm text-text-medium">{type.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
              Şifa & Enerji Hizmetleri
            </h2>
            <p className="text-text-medium text-lg">
              İhtiyacınıza özel enerji şifa seansları
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500"
              >
                <div className="flex items-start justify-between mb-4">
                  <h3 className="font-serif text-2xl font-bold text-primary-dark flex-1">
                    {service.title}
                  </h3>
                  <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center ml-4">
                    <i className="ri-heart-pulse-line text-gold text-xl"></i>
                  </div>
                </div>

                <p className="text-text-medium leading-relaxed mb-6">
                  {service.description}
                </p>

                <div className="flex items-center justify-between mb-6 pb-6 border-b border-gold/20">
                  <div className="flex items-center space-x-2">
                    <i className="ri-time-line text-gold"></i>
                    <span className="text-sm text-text-medium">{service.duration}</span>
                  </div>
                  <div className="text-gold font-semibold">{service.price}</div>
                </div>

                <div className="mb-6">
                  <h4 className="text-sm font-bold text-primary-dark mb-3">Seans İçeriği:</h4>
                  <ul className="space-y-2">
                    {service.includes.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-2 text-sm text-text-medium">
                        <i className="ri-check-line text-gold mt-0.5 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Link
                  to="/randevu"
                  className="block w-full py-3 bg-gold text-primary-dark text-center font-semibold rounded-full hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Randevu Al
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Suitable For */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="font-serif text-4xl font-bold text-primary-dark mb-4">
              Kimler İçin Uygun?
            </h2>
            <p className="text-text-medium text-lg">
              Enerji şifası, fiziksel ve ruhsal dengeyi arayanlar için
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {suitableFor.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="flex items-center space-x-4 bg-cream rounded-2xl p-6"
              >
                <div className="w-10 h-10 bg-gold/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-gold text-lg"></i>
                </div>
                <span className="text-text-medium font-medium">{item}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-primary-dark">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-4">
              Seans Süreci
            </h2>
            <p className="text-text-light text-lg">
              Enerji şifa seansı nasıl ilerler?
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { step: '1', title: 'Enerji Tarama', desc: 'Enerji alanınızı analiz ediyoruz' },
              { step: '2', title: 'Temizlik', desc: 'Blokajları ve negatif enerjiyi temizliyoruz' },
              { step: '3', title: 'Şifa', desc: 'Şifa enerjisi aktarıyoruz' },
              { step: '4', title: 'Dengeleme', desc: 'Enerji dengenizi sağlıyoruz' },
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-primary-navy rounded-2xl p-6 text-center"
              >
                <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-gold font-bold text-xl">{item.step}</span>
                </div>
                <h4 className="font-serif text-lg font-bold text-white mb-2">
                  {item.title}
                </h4>
                <p className="text-sm text-text-light">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-cream">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-serif text-3xl lg:text-4xl font-bold text-primary-dark mb-6">
              Enerji Dengenizi Sağlamaya Hazır mısınız?
            </h2>
            <p className="text-text-medium text-lg mb-8">
              Şifa enerjisi ile bedeninizi ve ruhunuzu yenileyin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
              <Link
                to="/randevu"
                className="px-8 py-4 bg-gold text-primary-dark font-semibold rounded-full hover:scale-105 hover:shadow-2xl hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Hemen Randevu Al
              </Link>
              <a
                href="https://wa.me/905555555555"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="px-8 py-4 border-2 border-primary-dark text-primary-dark font-semibold rounded-full hover:bg-primary-dark hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                WhatsApp ile Sor
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SifaEnerjiPage;